import { useTranslation } from 'react-i18next'

const MobileScreen = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="mobilescreen-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="mobilescreen-title">{t('antagonists:groomer:components:background')}</title>
      <defs>
        <clipPath id="mobilescreen-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#f9cec6}.f{fill:#f8f7f0}.g{fill:#eeeef0}.h{fill:#e7a958}.i{fill:#fee608}.j{fill:#c8d2ce}.k{fill:#3ca52b}.l{fill:#0a9791}.m{fill:#4a4630}.n{clip-path:url(#mobilescreen-b)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#mobilescreen-b)',
        }}
        id="mobilescreen-a"
      >
        <path
          style={{
            fill: '#c8d2ce',
          }}
          d="M-129.58-91.68h2274.44v1195.07H-129.58z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#eeeef0',
          }}
          d="m-246.03 902.65 2587.35-9.69-36.15 303.67-2516.4 132.48-34.8-426.46z"
        />
        <path
          d="M-169.06 1947.36c-36.43 0-70.45-6.62-101.96-19.89-31.29-13.18-60.01-33.02-85.36-58.98-20.23-20.72-38.37-45.35-53.92-73.21-26.45-47.4-36.09-87.17-36.49-88.84l7.89-1.88c.1.4 9.84 40.54 35.81 87 15.2 27.21 32.91 51.23 52.64 71.4 24.58 25.14 52.38 44.34 82.64 57.07 94.7 39.85 213.39 17.69 352.77-65.85 120.75-72.38 212.06-156.99 279.14-258.68 58.68-88.95 90.28-176.36 120.85-260.89 53.91-149.09 100.46-277.86 281.03-340.54 204.42-70.96 429.77-24.47 610.84 12.88 167.87 34.63 300.47 61.99 344.8-18.17 21.99-39.77 2.8-72.95-19.43-111.37-25.88-44.73-55.22-95.43-29-169.71 18.41-52.17 98.41-115.65 151.34-157.65 2.91-2.31 5.72-4.54 8.42-6.69 19.46-15.49 28.85-29.62 25.75-38.77-2.22-6.57-11.42-10.66-24.61-10.93-31.12-.63-95.3-.73-95.94-.73v-8.11c.66 0 64.91.1 96.11.73 17 .35 28.71 6.34 32.12 16.44 3.05 9.03.6 24.64-28.38 47.71-2.71 2.15-5.52 4.39-8.43 6.7-49.03 38.91-131.1 104.02-148.74 153.99-24.97 70.75 3.37 119.74 28.37 162.95 22.48 38.86 43.72 75.57 19.51 119.36-23.05 41.69-67.09 56.37-126.03 56.38-61.77 0-139.92-16.12-227.5-34.19-180.1-37.16-404.23-83.4-606.54-13.16-81.02 28.12-139.51 70.97-184.07 134.84-40.24 57.67-65.38 127.2-91.99 200.8-29.29 81.02-62.5 172.85-121.7 262.59-67.77 102.73-159.93 188.16-281.74 261.17-95.81 57.43-182.22 86.24-258.18 86.24Z"
          style={{
            fill: '#0a9791',
          }}
        />
        <path
          d="M1536.29 521.43s131.38.23 140.89-.83c11.02-1.22 12.51-4.69 16.83-8.06 4.04-3.16 6.7-5.42 9.76-5.78s67.65-6.69 67.65-6.69l-.2-24.1s-62.8-3.87-66.6-4.11-6.29-4.04-9.63-9.01c-5.04-7.51-15.04-7.7-24.93-7.82-8.83-.11-129.09 1.32-129.09 1.32l-4.67 65.08Z"
          style={{
            fill: '#3ca52b',
          }}
        />
        <path
          d="M459.86 429.01c-3.25 0-51.96-1.08-66.03 8.66s-90.93 127.74-94.18 127.74 69.28 193.77 69.28 193.77l122.32-86.6-31.39-243.57ZM507.47 859.16c5.36-1.33 64.66-31.17 85.3-29.96 20.65 1.21 163.45-11.02 181.62-24.46 34.94-25.85 33.93-57.06 33.93-57.06l-251.4 9.49-49.45 101.99Z"
          style={{
            fill: '#e7a958',
          }}
        />
        <path
          d="M487.56 196.9c-39.92 0-84.99 17.67-85.79 57.59-1.33 66.33-7.83 432.06-7.83 458.51 0 51.2 46.72 55.03 89.83 55.83 43.11.8 978.51 8.84 1011.79 6.59 41.06-2.78 66.36-17.47 72.11-59.29 5.45-39.62 5.73-397.71 5.73-440.03s-25.55-75.05-87.02-74.25c-76.64 1-975.65-4.94-998.81-4.94Z"
          style={{
            fill: '#4a4630',
          }}
        />
        <path
          d="M486.91 222.07c-38.57 0-63.74 18.06-64.51 56.63-1.28 64.09-5.81 373.51-6.58 399.06-1.37 45.35 23.41 68.36 65.07 69.14 41.66.77 972.76 7.3 1004.96 6 46.13-1.87 61.7-22.65 62.7-61.38 1-38.63.65-361.34.65-402.23s-5.19-66.28-64.59-65.51c-74.06.96-975.3-1.71-997.69-1.71Z"
          style={{
            fill: '#f8f7f0',
          }}
        />
        <path
          d="M213.22 1504.72s123.98-335.67 140.5-348.66c16.53-12.99 123.54-99.26 161.32-179.53 37.78-80.27 47.27-156.88 81.5-214.73 34.23-57.84 96.73-106.26 116.87-144.02 26.75-50.15-18.89-96.8-75.55-56.66S486.76 721.67 447.8 721.67s-60.2-107.42-66.11-145.2c-5.9-37.78-17.97-179.44-17.97-179.44l-88.27 4.73s-15.35 118.05-34.23 169.99c-18.89 51.94-42.5 109.79-38.96 134.58 3.54 24.79 2.36 226.65-24.79 301.02-30.79 84.34-314.01 409.63-314.01 409.63l349.76 87.74Z"
          style={{
            fill: '#e7a958',
          }}
        />
        <path
          d="M395.26 186.81S277.1 380.74 275.7 402.62c-1.49 23.47 33.64 52.48 62.58 46.55 28.93-5.94 34.17-38.85 43.14-71.46 8.96-32.62 60.18-112.36 59.24-140.72-1.68-50.37-45.4-50.17-45.4-50.17Z"
          style={{
            fill: '#e7a958',
          }}
        />
        <path
          d="m628.36 596.63 48.55 48.95s42.88-38.03 38.84-59.06c-4.05-21.04-23.46-38.03-39.65-31.96-16.18 6.07-47.74 42.07-47.74 42.07Z"
          style={{
            fill: '#f9cec6',
          }}
        />
        <path
          d="M443.06 469.11c-6.21 5.99-5.85 15.54-.1 21.07 5.75 5.54 14.39 6.24 20.72.33 6.57-6.13 5.7-15.6.19-21.24-5.22-5.35-14.79-5.97-20.8-.17Z"
          style={{
            fill: '#fee608',
          }}
        />
      </g>
    </svg>
  )
}

export default MobileScreen
